module.exports = __webpack_public_path__ + "img/3.b9f6f79f.png";